import { getAcademicSubjectsUrl } from "../config/Config";
import { getRequest, putRequest } from "./ServiceHelper";

export class SubjectService {
  static MANUAL = "manual";
  static FETCHED = "fetched";

  static getSubjects = ({
    withExternalContext = false,
    allSubjects = false,
  } = {}) => {
    const params = {
      withExternalContext: withExternalContext,
      allSubjects: allSubjects,
    };
    return getRequest(getAcademicSubjectsUrl(), params);
  };

  static upsertDepartment = (department, deadline) => {
    const payload = {
      title: department.title,
      name: department.name ?? department.title,
    };

    if (department.ddl_id) {
      payload.id = department.ddl_id;
      payload.creation_method =
        department.creation_method ?? SubjectService.FETCHED;
    } else {
      payload.creation_method = SubjectService.MANUAL;
    }

    if (deadline !== undefined || deadline !== null) {
      payload.days_after_term_finalization_deadline = deadline;
    }
    return putRequest(getAcademicSubjectsUrl(), { department: payload });
  };
}
